import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=1b3f9620&scoped=true"
import script from "@/controllers/products.js?vue&type=script&lang=js&external"
export * from "@/controllers/products.js?vue&type=script&lang=js&external"
import style0 from "./Products.styles.scss?vue&type=style&index=0&id=1b3f9620&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3f9620",
  null
  
)

export default component.exports